// extracted by mini-css-extract-plugin
export default {"popup_class":"HorizontalAlertsOptions_popup_class__+yZQQ","var_margin":"HorizontalAlertsOptions_var_margin__TfM1V"};